import React, {memo} from "react"
import {useTranslation} from "react-i18next";

import FormSection from "../../../components/FormSection";
import {formikPropertyChanged, generateMeasurementKey} from "./index";
import CollectionsTabList from "./CollectionsTabList";
import Model23MeasureField from "./Model23MeasureField";
import MeasurementsList from "./MeasurementsList";


const TemperatureProfiles = memo(({formik, emptyMeasure, emptyProfile, inputDisabled}) => {
    const {t} = useTranslation(['models23', 'enums']);

    const onProfilesUpdate = (profiles) => {
        formik.setFieldValue('temperatureProfiles', profiles);
    }

    const onMeasurementsUpdate = (profileIndex, measurements) => {
        formik.setFieldValue(`temperatureProfiles[${profileIndex}].measurements`, measurements);
    }

    const createEmptyMeasure = () => {
        return {...emptyMeasure, _key: generateMeasurementKey()}
    }

    const renderProfile = (profileIndex) => {
        return <TemperatureProfile formik={formik}
                                   profileIndex={profileIndex}
                                   createEmptyMeasure={createEmptyMeasure}
                                   onMeasurementsUpdate={(measurements) => onMeasurementsUpdate(profileIndex, measurements)}
                                   inputDisabled={inputDisabled}/>
    }

    return <FormSection title={t('model23Form.temperatureProfiles')}
                        openDefault={false}
                        error={Boolean(formik.errors.temperatureProfiles) && formik.touched.temperatureProfiles}>
        <CollectionsTabList collections={formik.values.temperatureProfiles}
                            renderCollection={renderProfile}
                            emptyCollection={emptyProfile}
                            onCollectionsUpdate={onProfilesUpdate}
                            inputDisabled={inputDisabled}/>
    </FormSection>
}, (prevProps, nextProps) => formikPropertyChanged(prevProps, nextProps, 'temperatureProfiles', true));


const TemperatureProfile = ({formik, profileIndex, createEmptyMeasure, onMeasurementsUpdate, inputDisabled}) => {
    const {t} = useTranslation(['models23']);

    const profile = formik.values.temperatureProfiles[profileIndex];
    const profilePrefix = `temperatureProfiles[${profileIndex}]`

    const headers = [
        t('model23Form.temperatureProfile.depth'),
        t('model23Form.temperatureProfile.temperature'),
    ]

    const renderMeasure = (row, index) => {
        return <>
            <Model23MeasureField formik={formik}
                                 label=""
                                 name={`${profilePrefix}.measurements[${index}].depth`}
                                 unitOfMeasure="cm"
                                 type="number"
                                 disabled={inputDisabled}/>
            <Model23MeasureField formik={formik}
                                 label=""
                                 name={`${profilePrefix}.measurements[${index}].temperature`}
                                 unitOfMeasure="°C"
                                 type="number"
                                 disabled={inputDisabled}/>
        </>
    }

    return <MeasurementsList headers={headers}
                             measurements={profile.measurements}
                             createEmptyMeasure={createEmptyMeasure}
                             onMeasurementsUpdate={onMeasurementsUpdate}
                             renderMeasure={renderMeasure}
                             inputDisabled={inputDisabled}/>
}

export default TemperatureProfiles;